import { useState, useEffect, createRef, useRef } from 'react'

import { SplitButton } from "@progress/kendo-react-buttons";
import TabSectionHeader from '../Jobs/TabSectionHeader'
import { Form, Field, FormElement } from '@progress/kendo-react-form'

import QuoteConvertForm from '../Quotes/QuoteConvertForm'
import JobConvertForm from '../Jobs/JobConvertForm'

import { getSitesDropdown } from '../../../data/siteData'
import { getClientsDropdown, getTargetClient } from '../../../data/clientData'
import { getDocuments, getTargetEnquiry } from '../../../data/enquiryData'
import { getEmployeeDropdown } from '../../../data/employeeData'
import { getWorktypeDropdown } from '../../../data/worktypeData'
import { getEnquirysourceDropdown } from '../../../data/enquirysourceData'
import { getDepartmentDropdown } from '../../../data/departmentData'

import { requiredValidator } from '../Validators'
import { DateFormatter } from '../../../data/helper'

import {
  FormTextArea,
  FormDropDownList,
  FormDropDownListFilter,
  FormDatePicker,
  FormAddressLookup,
} from '../FormComponents'
import { dropDown, fileDocumentTypes } from '../../../data/interfaces'

import SkeletonForm from '../../Skeletons/SkeletonForm'
import Divider from '../../Divider/Divider';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import Notes from '../../../pages/Notes/Notes';
import { addNoteDTO } from '../../../data/notes';
import EntityLinks from '../Links/EntityLinks';
import { useNavigate } from 'react-router-dom';
import { ExternalDropZone, Upload, UploadFileInfo, UploadFileStatus, UploadListItemProps, UploadOnStatusChangeEvent } from '@progress/kendo-react-upload';
import QuoteDocumentRow from '../../QuoteDocumentRow';
import { FaFileAlt, FaFileCsv, FaFileImage, FaFilePdf, FaFlag, FaClipboardList, FaPaperclip, FaHammer, FaRegStickyNote, FaLink, FaCamera } from 'react-icons/fa';
import EnquirySurvey from './EnquirySurvey';
import { useToast } from '../../../contexts/ToastContext';
import { getFullAddress, searchAddresses } from '../../../helpers/addressLookup';
import { AddressSuggestion, FullAddressResponse } from '../../../types/addressLookup.types';
import { getAddressesForClientDropdown, getClientByIdV2, getClientsForClientsDropdown } from '../../../data/accountsData';
import { deleteEnquiry, updateEnquiry } from '../../../data/enquiryData';
import type { updateEnquiryTypes } from '../../../data/interfaces';

// Workings imports
import WorkingSectionsView, { WorkingSectionsViewHandle } from '../../grids/WorkingSectionsView';
import WorkingsAdjustmentSummary from '../../grids/WorkingsAdjustmentSummary'
import { MaterialWorking, LabourWorking } from '../../../data/interfaces';
import { getMaterialWorkingsByEnquiry, getLabourWorkingsByEnquiry } from '../../../data/workingsData';

const EditEnquiryForm = (props: any) => {
    const dateFormatter = new DateFormatter()
  const [loading, setLoading] = useState(true)
  const enquiryId = props.onEnquiryId
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [siteDataOrig, setSiteDataOrig] = useState<dropDown[]>([])
  const [clientData, setClientData] = useState<dropDown[]>([])
  const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([])
  const [enquirysourceData, setEnquirysourceData] = useState<dropDown[]>([])
  const [worktypeData, setWorktypeData] = useState<dropDown[]>([])
  const [employeeData, setEmployeeData] = useState<dropDown[]>([])
  const [employeeProjectData, setEmployeeProjectData] = useState<dropDown[]>([])
  const [employeeDataOrig, setEmployeeDataOrig] = useState<dropDown[]>([])
  const [displayConvert, setDisplayConvert] = useState(false)
  const [convertText, setConvertText] = useState('Quote')
  const [departmentData, setDepartmentData] = useState<dropDown[]>([])

  const [isLostOrRejected, setIsLostOrRejected] = useState(false);
  const [isBadDebter, setIsBadDebter] = useState(false);

  const [clientContact, setClientContact] = useState<string>()
  const [clientAddress, setClientAddress] = useState<string>()
  const [clientPhone, setClientPhone] = useState<string>()
  const [clientEmail, setClientEmail] = useState<string>()

  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [projectUrlAlreadySet, setProjectUrlAlreadySet] = useState(false);
  
  // Workings state
  const [materialWorkings, setMaterialWorkings] = useState<MaterialWorking[]>([])
  const [labourWorkings, setLabourWorkings] = useState<LabourWorking[]>([])
  const [workingsAdjustmentPercent, setWorkingsAdjustmentPercent] = useState<number | null>(null)
  
  const token = localStorage.getItem('authToken')
  const uploadRef = createRef<Upload>()
  const workingSectionsRef = useRef<WorkingSectionsViewHandle>(null)
  const [files, setFiles] = useState<UploadFileInfo[]>([])


  const fetchDocumentData = async (enquiryId: number) => {
    await getDocuments(enquiryId)
      .then((data) => {
        setDocumentData(data)
      })

    console.log('documentData: ', documentData)
  }

  const items = [
    {
      text: 'Convert to Quote',
      value: 'quote'
    },
    {
      text: 'Convert to Job',
      value: 'job'
    }
  ];

  const [formState, setFormState] = useState({
    contact: {
      contactId: 0,
      title: "",
      firstname: "",
      lastname: "",
      phone: "",
      email: ""
    },
    site: {
      siteId: 0,
      siteAddr: "",
      postcode: "",
    },
    jobId: 0,
    quoteId: 0,
    ref: 0,
    refFormatted: '',
    jobRef: 0,
    quoteRef: 0,
    siteAddr: {
      text: '',
      value: 0,
    },
    clientName: {
      text: '',
      value: 0,
    },
    enquirysourceId: {
      text: '',
      value: 0,
    },
    description: '',
    dueDate: null as string | null,
    employeeAssignedToId: {
      text: '',
      value: 0,
    },
    worktypeId: {
      text: '',
      value: 0,
    },
    followupDate: '',
    cost: 0,
    enquiryId: enquiryId,
    purchaseOrder: '',
    proformaCost: '',
    departmentId: {
      text: '',
      value: 0,
    },
    startDate: '',
    endDate: '',
    employeeProjectmanager: {
      text: '',
      value: 0,
    },
    jobEmployeeIds: [{ value: 0, text: '' }],
    projectFolderUrl: null,
    deadDate: null as string | null,
    priorityId: 0
  })

  const animationStyle = displayConvert
    ? { animation: 'slide-in 0.5s ease-in-out' }
    : { animation: 'slide-out 0.5s ease-in-out' }

  const handleConvertDisplay = (e: any) => {
    if (e.nativeEvent && typeof e.nativeEvent.preventDefault === 'function') {
      e.nativeEvent.preventDefault();
    }
    setDisplayConvert(!displayConvert)
  }

  // const fetchSiteData = async () => {
  //   const siteData = await getSitesDropdown('')
  //   setSiteData(siteData)
  //   setSiteDataOrig(siteData)
  // }

  const fetchClientData = async () => {
    const clientData = await getClientsDropdown('')
    setClientData(clientData)
    setClientDataOrig(clientData)
  }

  const fetchExtendedClientData = async (clientId: number) => {
    const extendedClientdata = await getClientByIdV2(clientId);
    setClientContact(extendedClientdata.primaryContact.firstname + " " + (extendedClientdata.primaryContact.lastname || ""))
    setClientAddress(extendedClientdata.primarySite?.siteAddr + ", " + extendedClientdata.primarySite?.postcode)
    setClientPhone(extendedClientdata.primaryContact.phone)
    setClientEmail(extendedClientdata.primaryContact.email)
  }

  const fetchEnquirysourceData = async () => {
    const enquirysourceData = await getEnquirysourceDropdown()
    setEnquirysourceData(enquirysourceData)
  }

  const fetchEmployeeData = async () => {
    const employeeData = await getEmployeeDropdown('')
    setEmployeeData(employeeData)
    setEmployeeDataOrig(employeeData)
  }

  const fetchWorktypeData = async () => {
    const worktypeData = await getWorktypeDropdown()
    setWorktypeData(worktypeData)
  }

  const fetchDepartmentData = async () => {
    const departmentData = await getDepartmentDropdown()
    setDepartmentData(departmentData)
  }

  const fetchWorkingsData = async () => {
    try {
      const materialData = await getMaterialWorkingsByEnquiry(enquiryId)
      const labourData = await getLabourWorkingsByEnquiry(enquiryId)
      
      setMaterialWorkings(materialData)
      setLabourWorkings(labourData)
      
    } catch (error) {
      console.error('Error fetching workings data:', error)
    }
  }

  const fetchPlaceholderData = async () => {
    const enquiry = await getTargetEnquiry(enquiryId)
    setWorkingsAdjustmentPercent(enquiry.workingsAdjustmentPercent ?? null)

    // Surface the friendly enquiry reference to the drawer header.
    props.onEnquiryRefLoaded?.(enquiry.refFormatted)

    if (enquiry.client.clientId != undefined) {
      fetchExtendedClientData(enquiry.client.clientId);
      // Check if client is bad debter
      getClientByIdV2(enquiry.client.clientId).then((client) => {
        setIsBadDebter(client.badDebter || false);
      }).catch(() => {
        setIsBadDebter(false);
      });
    }

    setIsLostOrRejected(enquiry.deadDate !== null);

    setFormState({
      ...formState,
      contact: {
        contactId: enquiry.contact.contactId,
        title: enquiry.contact.title,
        firstname: enquiry.contact.firstname,
        lastname: enquiry.contact.lastname,
        phone: enquiry.contact.phone,
        email: enquiry.contact.email,
      },
      site: {
        siteId: enquiry.site.siteId,
        siteAddr: enquiry.site.siteAddr,
        postcode: enquiry.site.postcode,
      },
      ref: enquiry.ref,
      refFormatted: enquiry.refFormatted,
      jobRef: enquiry.jobRef,
      quoteRef: enquiry.quoteRef,
      siteAddr: {
        text: enquiry.site.siteAddr + ", " + enquiry.site.postcode,
        value: enquiry.site.siteId,
      },
      clientName: {
        text: enquiry.client.clientId != undefined ? enquiry.client.clientName + " - " + enquiry.client.accountRef : "",
        value: enquiry.client.clientId,
      },
      enquirysourceId: {
        text: enquiry.enquirysource.description,
        value: enquiry.enquirysource.enquirysourceId || 0,
      },
  description: enquiry.description,
  dueDate: enquiry.dueDate ?? null,
      employeeAssignedToId: {
        text: enquiry.employeeAssignedTo.employeeName,
        value: enquiry.employeeAssignedTo.employeeId || 0,
      },
      enquiryId: enquiryId,
      projectFolderUrl: enquiry.projectFolderUrl,
      deadDate: enquiry.deadDate ?? null,
      priorityId: enquiry.priority.priorityId || 0,
      jobId: enquiry.jobId || 0,
      quoteId: enquiry.quoteId || 0,
    })
    setProjectUrlAlreadySet(enquiry.projectFolderUrl !== null ? true : false)

    setLoading(false)
  }

  useEffect(() => {
    fetchWorktypeData()
    fetchEmployeeData()
    // fetchSiteData()
    fetchClientData()
    fetchEnquirysourceData()
    fetchDepartmentData()
    fetchWorkingsData()
    fetchPlaceholderData()
    fetchDocumentData(enquiryId)
    searchAddressDropdown(enquiryId)
  }, [enquiryId])

// console.log("ofmr", formState)

  //Handle submits
  const handleSubmit = () => {
    console.log('handleSubmit - Original formState.dueDate:', formState.dueDate);
    // Always send dueDate as local date string (YYYY-MM-DD) to avoid timezone issues
    let safeDueDate = formState.dueDate;
    if (safeDueDate) {
      const parsed = new Date(safeDueDate);
      if (isNaN(parsed.getTime())) {
        safeDueDate = '';
      } else {
        // Use local date in YYYY-MM-DD format to avoid timezone conversion
        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        safeDueDate = `${year}-${month}-${day}`;
      }
    } else {
      safeDueDate = '';
    }
    console.log("handleSubmit - Processed safeDueDate:", safeDueDate);

    const dataToSubmit = {
      ...formState,
      dueDate: safeDueDate
    };
    console.log("handleSubmit - Data being submitted:", dataToSubmit);
    
    // The adjustment percentage lives outside formState because it belongs to
    // the workings tab rather than the enquiry form, so fold it in here.
    props.onEditSubmit({ ...dataToSubmit, workingsAdjustmentPercent }, enquiryId)
  }

  const handleConvertQuoteSubmit = (data: any) => {
    const updatedFormState = {
      ...formState,
      worktypeId: {
        text: data.worktypeId.text,
        value: data.worktypeId.value,
      },
      cost: 0,
      followupDate: data.followupDate,
    }

    setFormState(updatedFormState);

    props.onConvertQuoteSubmit(updatedFormState, enquiryId)
  }

  const handleConvertJobSubmit = (data: any) => {
    const updatedFormState = {
      ...formState,
      proformaCost: data.proformaCost,
      purchaseOrder: data.purchaseOrder,
      worktypeId: {
        text: data.worktypeId.text,
        value: data.worktypeId.value,
      },
      cost: 0,
      followupDate: data.followupDate,
      departmentId: {
        text: data.departmentId.text,
        value: data.departmentId.value,
      },
      startDate: data.startDate,
      endDate: data.endDate,
      employeeProjectmanager: {
        text: data.employeeProjectmanager.text,
        value: data.employeeProjectmanager.value,
      },
      jobEmployeeIds: [],
      notifiableWorks: data.notifiableWorks,
    }

    setFormState(updatedFormState);

    props.onConvertJobSubmit(updatedFormState, enquiryId)
  }

  const handleReinstateEnquiry = async () => {
    try {
      const token = localStorage.getItem('authToken')
      await fetch(`https://${apiURL}/Enquiries/reinstate/${enquiryId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type':  'application/json',
        }
      })
      showToast('Enquiry successfully reinstated', 'success')
      setIsLostOrRejected(false)
      
      // Close panel and refresh grid
      if (props.onClose) {
        props.onClose()
      }
      if (props.onRefresh) {
        props.onRefresh()
      }
    } catch (err) {
      // console.error(err)
      showToast('Failed to reinstate enquiry', 'error')
    }
  }

  const handleDeleteEnquiry = (event: any) => {
    event.preventDefault()
    props.onDeleteSubmit(enquiryId)
  }

  const handleRejectEnquiry = async () => {
    try {
      const token = localStorage.getItem('authToken')
      await fetch(`https://${apiURL}/Enquiries/markasdead/${enquiryId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type':  'application/json',
        }
      })
      showToast('Enquiry successfully rejected', 'success')
      setIsLostOrRejected(true)
      
      // Close panel and refresh grid
      if (props.onClose) {
        props.onClose()
      }
      if (props.onRefresh) {
        props.onRefresh()
      }
    } catch (err) {
      // console.error(err)
      showToast('Failed to reject enquiry', 'error')
    }
  }


  //Search filters
  const searchSiteDropdown = (searchTerm: string) => {
    const fetchSiteData = async (search: string) => {
      await getSitesDropdown(search).then((result) => {
        setSiteData(result)
      })
    }

    fetchSiteData(searchTerm)
  }

  const searchAddressDropdown = async (accountId: number) => {
    try {
      const res = await getAddressesForClientDropdown(accountId);
    } catch (err) {
      console.log(err)
    }
  }

  const searchClientDropdown = (searchTerm: string) => {
    const fetchClientData = async (search: string) => {
      await getClientsDropdown(search).then((result) => {
        setClientData(result)
      })
    }

    fetchClientData(searchTerm)
  }

  const searchEmployeeDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }

  const searchEmployeeProjectDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeProjectData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }


  const handleAddSite = () => {
    props.onAddSiteToggle()
  }

  const handleConvertChange = (e: any) => {
    if (e.item.value === 'quote') {
      setConvertText('Quote')
    } else {
      setConvertText('Job')
    }
  }

  const handleSelectedTab = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected);
    fetchDocumentData(enquiryId)
  }

  const addNoteDTO: addNoteDTO = {
    enquiryId: enquiryId,
    quoteId: null,
    jobId: null
  };

  const checkForProjectUrl = () => {
    const url = formState.projectFolderUrl;
    if (url !== null) {
      const path: string = url;
      if (path.includes("https://")) {
        return <a href={path} target="_blank" rel="noreferrer">View folder structure</a>
      } else {
        return <div><strong>Generating folder structure... Please check back soon.</strong></div>
      }
    }
  }

  const icon = (fileName: string) => {
    if (fileName.includes('.pdf')) {
      return (
        <FaFilePdf
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    } else if (fileName.includes('.csv')) {
      return (
        <FaFileCsv
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    } else if (fileName.includes('.txt')) {
      return (
        <FaFileAlt
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    } else if (fileName.includes('.jpg')) {
      return (
        <FaFileImage
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    } else if (fileName.includes('.png')) {
      return (
        <FaFileImage
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    } else {
      return (
        <FaFileAlt
          style={{
            fontSize: '20pt',
            color: 'rgb(33, 67, 59)',
            marginRight: '1rem',
          }}
        />
      )
    }
  }

  const [documentData, setDocumentData] = useState<fileDocumentTypes[]>([
    {
      documentId: 0,
      fileName: '',
      fileExtension: '',
      appCanView: false,
    },
  ])

  // Survey photos are enquiry documents too; list them after the general
  // files under their own heading so they're easy to pick out.
  const generalDocuments = documentData.filter((document) => !document.isSurveyFile)
  const surveyDocuments = documentData.filter((document) => document.isSurveyFile)

  const CustomListItemUI = (props: UploadListItemProps) => {
    return (
      <ul>
        {props.files.map((file) => (
          <div
            style={{ fontSize: '10pt', fontFamily: 'Heebo, Sans-Serif' }}
            key={file.name}
          >
            {icon(file.name)}
            {file.name}
          </div>
        ))}
      </ul>
    )
  }

  const handleDocumentDelete = (documentId: number) => {
    props.onDocumentDelete(documentId)
    setDocumentData(
      documentData.filter((document: any) => document.documentId !== documentId)
    )
  }

  const { showToast } = useToast()


  const handleUploadSuccess = (event: UploadOnStatusChangeEvent) => {
    setFiles(event.newState)

    // onStatusChange also fires when an upload starts or fails, so only act on
    // files that actually finished uploading. Refresh the document list so the
    // newly uploaded file appears without needing to reload the form.
    const uploaded = event.affectedFiles.some(
      (file) => file.status === UploadFileStatus.Uploaded
    )
    const failed = event.affectedFiles.some(
      (file) => file.status === UploadFileStatus.UploadFailed
    )

    if (uploaded) {
      showToast('Succesfully uploaded new document', 'success')
      fetchDocumentData(enquiryId)
    } else if (failed) {
      showToast('Failed to upload document', 'error')
    }
  }
  const apiURL = process.env.REACT_APP_API_URL

  const navigate = useNavigate();

  /**
   * Account and address selection
   */

  const [accountData, setAccountData] = useState<dropDown[]>([]);


  const getAndStoreAddressesForCustomer = async (customerId: number) => {
    try {
      const res = await getAddressesForClientDropdown(customerId);
      setSiteData(res);
      setFormState((prev) => ({
        ...prev,
        siteAddr: {
          text: res.length === 1 ? res[0]?.text || '' : formState.siteAddr.text,
          value: res.length === 1 ? res[0]?.value || 0 : formState.siteAddr.value,
        }
      }))
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientName.value !== 0) {
      getAndStoreAddressesForCustomer(formState.clientName.value);
    }
  }, [formState.clientName])

  /**
   * End Account and address selection
   */

  // Contacts for client
  const [contactsForClient, setContactsForClient] = useState<dropDown[]>([]);

  const getAndStoreContactsForCustomer = async (customerId: number) => {
    try {
      const res = await getClientsForClientsDropdown(customerId);
      setContactsForClient(res);
      setFormState((prev: any) => ({
        ...prev,
        contact: {
          ...formState.contact,
          contactId: res.length === 1 ? res[0]?.value || 0 : formState.contact.contactId,
        }
      }))

    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (formState.clientName.value !== 0) {
      getAndStoreContactsForCustomer(formState.clientName.value);
    }
  }, [formState.clientName])

// console.log(formState)

  // Single source of truth for the tab order. Kendo TabStrip assigns each
  // rendered <TabStripTab> a numeric index in DOM order and filters out falsy
  // children — so when lockEdit hides File Upload every later index shifts down
  // by one. This array mirrors that exactly, and the rail maps a section id ->
  // index via indexOf, so the two can never drift apart.
  const enquiryTabOrder = [
    'enquiryForm',
    'survey',
    ...(props.lockEdit ? [] : ['files']),
    'workings',
    'notes',
    'links',
  ]

  // The rail sets the tab directly rather than through the TabStrip's onSelect,
  // so refresh the file list here too - photos added in Survey Notes should be
  // there when the user moves over to Files.
  useEffect(() => {
    if (enquiryTabOrder[selectedTab] === 'files') {
      fetchDocumentData(enquiryId)
    }
  }, [selectedTab])

  const enquiryNavGroups = [
    {
      label: 'Details',
      items: [
        { id: 'enquiryForm', label: 'Enquiry Form' },
        { id: 'survey', label: 'Survey Notes' },
        { id: 'workings', label: 'Workings' },
      ],
    },
    {
      label: 'Attachments',
      items: [
        ...(props.lockEdit ? [] : [{ id: 'files', label: 'Files' }]),
        { id: 'notes', label: 'Notes' },
        { id: 'links', label: 'Links' },
      ],
    },
  ]

  return loading ? (
    <SkeletonForm />
  ) : (
    <div className='form__wrapper'>
      <div style={{ display: 'flex', width: '100%', flex: 1, minHeight: 0, height: '100%' }}>
        <nav className='jobnav__rail'>
          {enquiryNavGroups.map((group) => (
            <div key={group.label} className='jobnav__group'>
              <div className='jobnav__group-label'>{group.label}</div>
              {group.items.map((item) => {
                const idx = enquiryTabOrder.indexOf(item.id)
                const active = selectedTab === idx
                return (
                  <button
                    key={item.id}
                    type='button'
                    className={`jobnav__item${active ? ' active' : ''}`}
                    onClick={() => setSelectedTab(idx)}
                  >
                    <span className='jobnav__item-label'>{item.label}</span>
                  </button>
                )
              })}
            </div>
          ))}
        </nav>
        <TabStrip
          selected={selectedTab}
          onSelect={handleSelectedTab}
          className='form__tabstrip__container jobnav__tabstrip'
          animation={false}
        >
          <TabStripTab title="Enquiry Form">
            <div style={{ paddingTop: '1rem' }}>
              <TabSectionHeader
                icon={<FaClipboardList />}
                title="Enquiry Details"
                description="Core details and settings for this enquiry"
              />
            </div>
            <Form
              initialValues={{ description: formState.description }}
              render={(formRenderProps) => (
                <FormElement style={{ padding: '1rem', width: '100%', marginBottom: '5rem' }} >
                  <fieldset className={'k-form-fieldset'}>
                    <div className='form__edit__container'>
                      {(formState.jobRef || formState.quoteRef) && (
                        <div className='jobmeta__chips'>
                          {formState.jobRef ? <span className='jobmeta__chip' onClick={() => window.open(`/jobs/?id=${formState.jobId}`, "_blank")}>Job J{formState.jobRef}</span> : null}
                          {formState.quoteRef ? <span className='jobmeta__chip' onClick={() => window.open(`/quotes/?id=${formState.quoteId}`, "_blank")}>Quote Q{formState.quoteRef}</span> : null}
                        </div>
                      )}

                      <div className='form__details__subcontainer'>
                        <p style={{ margin: 0, fontSize: "9pt", fontWeight: "400", letterSpacing: "normal" }}>Client Contact: {`${formState.contact?.title || ""} ${formState.contact?.firstname || ""} ${formState.contact?.lastname || ""}`}</p>
                        <p style={{ margin: 0, fontSize: "9pt", fontWeight: "400", letterSpacing: "normal" }}>Client Address: {`${formState.site.siteAddr || ""}`}</p>
                        <p style={{ margin: 0, fontSize: "9pt", fontWeight: "400", letterSpacing: "normal" }}>Client Phone: {formState.contact.phone || ""}</p>
                        <p style={{ margin: 0, fontSize: "9pt", fontWeight: "400", letterSpacing: "normal" }}>Client Email: <a href={`mailto:${formState.contact.email}`}>{formState.contact.email}</a></p>
                      </div>

                      <Divider>
                        General Info
                      </Divider>

                      {/* <Field
                      disabled={props.lockEdit}
                      data={accountData}
                      name={'account'}
                      component={FormDropDownListFilter}
                      label={'Account:'}
                      setData={setAccountData}
                      searchDropdown={getAndStoreAccountsForDropDown}
                      defaultItem={formState.siteAddr}
                      onChange={(e) => {
                        setFormState({
                          ...formState,
                          clientName: {
                            ...e.value,
                            value: parseInt(e.value.value, 10),
                          },
                        })
                      }}
                      hasButton={props.lockEdit ? false : true}
                      buttonText={'Add Account'}
                      buttonAction={() => props.setAddAccountVisible(true)}
                    />                     */}

                      <Field
                        disabled={props.lockEdit}
                        data={clientData}
                        originalData={clientDataOrig}
                        name={'clientName'}
                        component={FormDropDownListFilter}
                        label={'Choose a client:'}
                        setData={setClientData}
                        searchDropdown={searchClientDropdown}
                        defaultItem={formState.clientName}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            clientName: {
                              ...e.value,
                              value: parseInt(e.value.value, 10),
                            },
                          })
                        }}
                        required={true}
                        hasButton={props.lockEdit ? false : true}
                        buttonText={'Add Account'}
                        buttonAction={() => {
                          props.setAddAccountVisible(true)
                          props.setAccountMode("add");
                          props.setAccountInitialTab(0);
                        }}
                      />



                      <Field
                        disabled={props.lockEdit}
                        data={contactsForClient}
                        originalData={siteDataOrig}
                        name={'contact'}
                        required={true}
                        component={FormDropDownListFilter}
                        label={'Contact:'}
                        setData={setContactsForClient}
                        onOpen={() => getAndStoreContactsForCustomer(formState.clientName.value)}
                        searchDropdown={searchSiteDropdown}
                        defaultItem={contactsForClient.find(item => Number(item.value) === Number(formState.contact.contactId))}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            contact: {
                              ...e.value,
                              contactId: parseInt(e.value.value, 10),
                            }
                          })
                        }}
                        hasButton={props.lockEdit ? false : formState.clientName.value > 0}
                        buttonText={'Add Contact'}
                        buttonAction={() => {
                          props.setAccountMode("edit");
                          props.setSelectedAccountId(formState.clientName.value);
                          props.setAccountInitialTab(2);
                          props.setAddAccountVisible(true)
                        }}
                      />

                      <Field
                        disabled={props.lockEdit}
                        data={siteData}
                        required={true}
                        originalData={siteDataOrig}
                        name={'address'}
                        component={FormDropDownList}
                        label={'Address:'}
                        setData={setSiteData}
                        onOpen={() => getAndStoreAddressesForCustomer(formState.clientName.value)}
                        searchDropdown={searchSiteDropdown}
                        defaultItem={siteData.find(item => Number(item.value) === Number(formState.siteAddr.value))}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            siteAddr: {
                              ...e.value,
                              value: parseInt(e.value.value, 10),
                            },
                          })
                        }}
                        hasButton={props.lockEdit ? false : formState.clientName.value > 0}
                        buttonText={'Add Address'}
                        buttonAction={() => {
                          props.setAccountMode("edit");
                          props.setSelectedAccountId(formState.clientName.value);
                          props.setAccountInitialTab(1);
                          props.setAddAccountVisible(true)
                        }}
                      />

                      <Field
                        disabled={props.lockEdit}
                        data={enquirysourceData}
                        name={'enquirysourceId'}
                        component={FormDropDownList}
                        label={'Choose enquiry source:'}
                        setData={setEnquirysourceData}
                        defaultText={formState.enquirysourceId.text}
                        defaultValue={formState.enquirysourceId.value}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            enquirysourceId: {
                              ...e.value,
                              value: parseInt(e.value.value, 10),
                            },
                          })
                        }}
                      />

                      <Field
                        disabled={props.lockEdit}
                        name={'dueDate'}
                        component={FormDatePicker}
                        label={'Due Date:'}
                        required={true}
                        defaultText={formState.dueDate}
                        validator={requiredValidator}
                        placeholder={formState.dueDate ? dateFormatter.format(formState.dueDate) : ''}
                        onChange={(e) => {
                          setFormState({ ...formState, dueDate: e.value })
                        }}
                      />

                      <Field
                        disabled={props.lockEdit}
                        name={'description'}
                        component={FormTextArea}
                        label={'Enquiry description:'}
                        defaultValue={formState.description}
                        onChange={(e) => {
                          setFormState({ ...formState, description: e.value })
                        }}
                      />

                      {isBadDebter && (
                        <div style={{
                          backgroundColor: '#fff3cd',
                          border: '1px solid #ffc107',
                          borderRadius: '4px',
                          padding: '12px 16px',
                          marginTop: '8px',
                          marginBottom: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          color: '#856404'
                        }}>
                          <FaFlag style={{ fontSize: '18px', color: '#ffc107' }} />
                          <span style={{ fontWeight: '600' }}>Contact accounts department</span>
                        </div>
                      )}

                      <Field
                        disabled={props.lockEdit}
                        data={employeeData}
                        originalData={employeeDataOrig}
                        name={'employeeAssignedToId'}
                        component={FormDropDownListFilter}
                        label={'Assigned employee:'}
                        setData={setEmployeeData}
                        defaultItem={formState.employeeAssignedToId}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            employeeAssignedToId: {
                              ...e.value,
                              value: parseInt(e.value.value, 10),
                            },
                          })
                        }}
                      />
                    </div>

                    {displayConvert && <div className='overlay'></div>}

                    {displayConvert ? (
                      <div
                        className='form__convert__container'
                        style={animationStyle}
                      >
                        {convertText === 'Quote' && (
                          <QuoteConvertForm
                            onHandleConvertSubmit={handleConvertQuoteSubmit}
                            onHandleConvertDisplay={handleConvertDisplay}
                            onWorktypeData={worktypeData}
                          />
                        )}
                        {convertText === 'Job' && (
                          <JobConvertForm
                            onHandleConvertSubmit={handleConvertJobSubmit}
                            onNotifiableWorksMissing={() =>
                              showToast('Please select at least one notifiable work', 'error')
                            }
                            onHandleConvertDisplay={handleConvertDisplay}
                            onWorktypeData={worktypeData}
                            onDepartmentData={departmentData}
                            onEmployeeData={employeeData}
                            onEmployeeProjectData={employeeProjectData}
                            onEmployeeDataOrig={employeeDataOrig}
                            onSearchEmployeeDropdown={searchEmployeeDropdown}
                            onSearchEmployeeProjectDropdown={searchEmployeeProjectDropdown}
                            onSetEmployeeData={setEmployeeData}
                          />
                        )}
                      </div>
                    ) : null}

                    {
                      !projectUrlAlreadySet && (
                        <Field
                          disabled={props.lockEdit}
                          data={[
                            { text: "M&E", value: 1 },
                            { text: "Construction", value: 2 }
                          ]}
                          name={'selectStructure'}
                          component={FormDropDownList}
                          label={'Select folder structure'}
                          onChange={(e) => {
                            setFormState({ ...formState, projectFolderUrl: e.value.text === undefined ? null : e.value.text })
                          }}
                        />
                      )
                    }

                    {
                      projectUrlAlreadySet && (
                        <>
                          <br />
                          <label style={{ fontSize: "10pt", color: "rgb(36, 32, 56)" }} className="k-label">Folder structure</label>
                          {checkForProjectUrl()}
                        </>

                      )
                    }
                    {
                      props.lockEdit === false ? (
                        <div className='button__container'>
                          <button
                            onClick={() => {
                              handleSubmit()
                              formRenderProps.onFormReset()
                            }}
                            disabled={formState.clientName.value === 0 || formState.siteAddr.value === 0 || formState.contact.contactId === 0}
                            className='form__edit__button edit'
                          >
                            Save changes
                          </button>

                          <SplitButton
                            items={items}
                            onButtonClick={handleConvertDisplay}
                            className='form__edit__button accept'
                            text={`Convert to ${convertText}`}
                            onItemClick={handleConvertChange}
                          />
                          
                          {
                            isLostOrRejected ? (
                              <button
                                onClick={handleReinstateEnquiry}
                                className='form__edit__button accept'
                              >
                                Reinstate Enquiry
                              </button>
                            ) : (
                              <button
                                onClick={handleRejectEnquiry}
                                className='form__edit__button reject'
                              >
                                Reject Enquiry
                              </button>
                            )
                          }
                        </div>

                      ) : null
                    }
                  </fieldset>
                </FormElement>
              )}
            />
          </TabStripTab>
          <TabStripTab title='Survey Notes'>
            <TabSectionHeader
              icon={<FaCamera />}
              title="Survey Notes"
              description="Notes and photos from the site survey"
            />
            <EnquirySurvey enquiryId={enquiryId} lockEdit={props.lockEdit} />
          </TabStripTab>
          {
            props.lockEdit === false ? (
              <TabStripTab title='File Upload'>
                <TabSectionHeader
                  icon={<FaPaperclip />}
                  title="Files"
                  description="Upload and manage documents for this enquiry"
                />
                <div style={{ padding: '0 1rem 1rem' }}>
                <ExternalDropZone
                  style={{ fontSize: '10pt', fontFamily: 'Heebo, sans-serif' }}
                  uploadRef={uploadRef}
                />
                <div style={{ height: '20px' }} />
                <Upload
                  ref={uploadRef}
                  batch={true}
                  files={files}
                  multiple={true}
                  defaultFiles={[]}
                  withCredentials={false}
                  listItemUI={CustomListItemUI}
                  saveHeaders={{ Authorization: `Bearer ${token}` }}
                  saveUrl={token ? `https://${apiURL}/Files/Enquiry/${enquiryId}` : ''}
                  onStatusChange={handleUploadSuccess}
                />

                <div style={{ height: '1.5rem' }} />

                <div>
                  {documentData.length > 0 ? (
                    <div>
                      {generalDocuments.map((document: fileDocumentTypes) => (
                        <QuoteDocumentRow
                          key={document.documentId}
                          onDocumentId={document.documentId}
                          onFileName={document.fileName}
                          onFileExtension={document.fileExtension}
                          appCanView={document.appCanView}
                          onDocumentDelete={handleDocumentDelete}
                        />
                      ))}
                      {surveyDocuments.length > 0 && (
                        <>
                          <div className='k-label' style={{ fontSize: '10pt', fontWeight: 600, margin: '1rem 0 0.5rem' }}>
                            Survey files ({surveyDocuments.length})
                          </div>
                          {surveyDocuments.map((document: fileDocumentTypes) => (
                            <QuoteDocumentRow
                              key={document.documentId}
                              onDocumentId={document.documentId}
                              onFileName={document.fileName}
                              onFileExtension={document.fileExtension}
                              appCanView={document.appCanView}
                              isSurveyFile={document.isSurveyFile}
                              onDocumentDelete={handleDocumentDelete}
                            />
                          ))}
                        </>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        padding: '1rem',
                        backgroundColor: 'rgb(216 229 237)',
                        borderRadius: '0.5rem',
                        alignItems: 'center',
                      }}
                    >
                      <p style={{ margin: 0 }}>No files uploaded yet</p>
                    </div>
                  )}
                </div>
                </div>
              </TabStripTab>
            ) : null
          }
          <TabStripTab title='Workings'>
            <TabSectionHeader
              icon={<FaHammer />}
              title="Workings"
              description="Material and labour breakdown for this enquiry"
              actions={
                <button
                  type="button"
                  onClick={() => workingSectionsRef.current?.openAddSection()}
                  className="jobsection__action-btn"
                >
                  Add Section
                </button>
              }
            />
            <div style={{ padding: '0 1rem 1rem' }}>
              <WorkingSectionsView
                ref={workingSectionsRef}
                hideToolbar
                enquiryId={enquiryId}
                lockEdit={props.lockEdit}
                materialWorkings={materialWorkings}
                onMaterialWorkingsChange={setMaterialWorkings}
                labourWorkings={labourWorkings}
                onLabourWorkingsChange={setLabourWorkings}
              />

              <WorkingsAdjustmentSummary
                materialWorkings={materialWorkings}
                labourWorkings={labourWorkings}
                adjustmentPercent={workingsAdjustmentPercent}
                onAdjustmentPercentChange={setWorkingsAdjustmentPercent}
                lockEdit={props.lockEdit}
              />
            </div>
          </TabStripTab>
          
          <TabStripTab title="Notes">
            <TabSectionHeader
              icon={<FaRegStickyNote />}
              title="Notes"
              description="Internal notes and comments for this enquiry"
            />
            <Notes lockEdit={props.lockEdit} sourceEntity={addNoteDTO} />
          </TabStripTab>
          <TabStripTab title="Links">
            <TabSectionHeader
              icon={<FaLink />}
              title="Links"
              description="Related web links and resources for this enquiry"
            />
            <EntityLinks lockEdit={props.lockEdit} sourceEntity={addNoteDTO} />
          </TabStripTab>
        </TabStrip>
      </div>
    </div>
  )
}

export default EditEnquiryForm
